<template>
    <div class="grow pointer mt3 bg-white custom-shadow">
        <img class="w-100" :src="image">
        <div style="padding-top:20px; padding-bottom:20px;" class="ph3-ns">
            <h5 :class="{'tc' : xs}">{{category}}</h5>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String
        },
        category: {
            type: String
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>

<style scoped>
.lightGrey {
    background-image: url('../../assets/img/tooliaba_seemless_texture_1.jpg');
    background-repeat: repeat;
}
</style>
